import { useQueries } from '@tanstack/react-query'
import { useConfig } from 'wagmi'

import { SimplifiedQueryResult } from '@/domain/common/query'
import { useSandbox } from '@/domain/sandbox/useSandbox'
import { vpnCheckQueryOptions } from '@/features/compliance/logic/vpnCheckQueryOptions'
import {
  OngoingCampaign,
  ongoingCampaignsQueryOptions,
} from '@/features/spark-rewards/data/ongoingCampaignsQueryOptions'

export type OngoingCampaignWithRestrictedCountry = OngoingCampaign & {
  isGeoBlocked: boolean
}

export type UseOngoingCampaignsQueryResult = SimplifiedQueryResult<OngoingCampaignWithRestrictedCountry[]>

export function useOngoingCampaignsQuery(): UseOngoingCampaignsQueryResult {
  const wagmiConfig = useConfig()
  const { isInSandbox } = useSandbox()

  return useQueries({
    queries: [ongoingCampaignsQueryOptions({ wagmiConfig, isInSandbox }), vpnCheckQueryOptions()],
    combine: ([campaigns, vpnCheck]) => {
      if (campaigns.isPending || vpnCheck.isPending) {
        return { isPending: true, isError: false, error: null, data: undefined }
      }

      if (campaigns.isError) {
        return { isPending: false, isError: true, error: campaigns.error }
      }

      const data = campaigns.data.map((campaign) => ({
        ...campaign,
        isGeoBlocked: campaign.restrictedCountryCodes.some((code) => code === vpnCheck.data?.countryCode),
      }))

      return { isPending: false, isError: false, error: null, data }
    },
  })
}
